///<reference path='../../typings/index.d.ts' />
module agi.expressions.card.layer{
    /**
     * Container designed to hold all the necessary components for a Hidden Object.
     * @author Brian Emling
     * @author Dan Singer
     */
    export class HiddenObj extends PIXI.Container{
        public hideSprite:PIXI.Sprite;
        public foundSprite:PIXI.Sprite;
        public isHidden:boolean = false;
        public fadeTL:TimelineMax=new TimelineMax();
        /**
         * Construct a new Hidden Object
         * @param hideSprite Sprite for the normal state of a HiddenObject
         * @param foundSprite Sprite for the found state of a HiddenObject
         * @param onFound callback that occurs when the HiddenObject is found
         */
        constructor(hideSprite:PIXI.Sprite, foundSprite:PIXI.Sprite, onFound:() => void){
            super();
            this.hideSprite = hideSprite;
            this.hideSprite.interactive=true;
            if (onFound)
            {
                this.hideSprite.on('click',onFound);
                this.hideSprite.on('tap',onFound);
            }
            this.foundSprite = foundSprite;
            this.foundSprite.visible = false;
            this.addChild(this.hideSprite, this.foundSprite);
        }
    }
}